import { render, staticRenderFns } from "./certificstuonFile.vue?vue&type=template&id=370915be&scoped=true&"
import script from "./certificstuonFile.vue?vue&type=script&lang=js&"
export * from "./certificstuonFile.vue?vue&type=script&lang=js&"
import style0 from "./certificstuonFile.vue?vue&type=style&index=0&id=370915be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370915be",
  null
  
)

export default component.exports